import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ModalController, ToastController } from '@ionic/angular';
import * as moment from 'moment';
import { ViewGoalsPage } from '../../../../../dashboard/goals-progress/view-goals/view-goals.page';
import { Goal } from '../../../../../goals/_interfaces/goal.interface';
import { SelfEvaluationRecord } from '../../../../../self-evaluation/_interfaces/self-evaluation-record.interface';
import { BaseClass } from '../../../../classes/base';
import { QuestionConfig, QuestionTypeConfig, QuestionViewType } from '../../../../interfaces/process-config.interface';
import { TranslationService } from '../../../../services/translation.service';
import { UtilService } from '../../../../services/util.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';
import { GoalDescriptionModal } from 'src/app/shared/modals/goal-description/goal-description.modal';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-grouped-slider-questions',
    templateUrl: './grouped-slider-questions.component.html',
    styleUrls: ['./grouped-slider-questions.component.scss', '../../question-types.component.scss'],
})
export class GroupedSliderQuestionsComponent extends BaseClass implements OnInit {
    public QuestionViewType = QuestionViewType;
    public highlightSelfOrManagerEvalAnswer: boolean;
    public typeConfigDescriptionEnabled: boolean;
    public hideSubordinateAnswer: boolean;

    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() evaluation?: SelfEvaluationRecord = null;
    @Input() isManagerComment: boolean = false;
    @Input() descriptionTooltip: string = '';
    @Input() hideQuestionTitle: boolean = false;
    @Input() managerAnswer: boolean = false;
    @Input() cycleId: number = 0;
    @Input() subordinatedId: string = null;
    @Input() setTooltip: (question: QuestionConfig, vIndex: number) => boolean;
    @Input() openDescriptionConcept: (title: string, description: string, index: number) => boolean;
    @Input() showRequiredBadge: (formGroup: UntypedFormGroup, index: number) => boolean;
    @Input() getQuestionAnswer: (question: QuestionConfig, gIndex?: number) => boolean;
    @Input() setRangeValue: (key: string, value: string, typeConfig?: QuestionTypeConfig, index?: number) => boolean;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
        private route: ActivatedRoute,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.cycleId = Number(this.route.snapshot.paramMap.get('cycleId'));
        this.highlightSelfOrManagerEvalAnswer = this._configService.settings.features.highlightSelfOrManagerEvalAnswer;
        this.typeConfigDescriptionEnabled = this._configService.settings.features.typeConfigDescriptionEnabled;
        this.hideSubordinateAnswer = this._configService.settings.features.hideSubordinateAnswerManagerEvaluation;
    }

    public getProgressBarLength(goal: Goal) {
        return { width: goal.currentProgress + '%' };
    }

    public async viewGoalModal(goal: Goal) {
        //alt_style -> process-user-list
        const goalModal = await this._modalController.create({
            component: ViewGoalsPage,
            cssClass: 'view-goals-modal-style',
            componentProps: {
                'goalId': goal.id,
                'allowComments': true,
                'cycleId': this.cycleId,
                'subordinatedId': this.subordinatedId
            }
        });
        await goalModal.present();
    }

    public getProgressBarColor(goal: Goal, color: string): boolean {
        const momentDueDate = moment(goal.deadline).startOf('day');
        const momentToday = moment().startOf('day');
        const diff = moment.duration(momentDueDate.diff(momentToday)).asDays();

        if (diff <= 10 && diff > 3)
            return color === 'warning';

        if (diff > 0 && diff <= 3)
            return color === 'danger';

        return color === 'primary';
    }
    public async openGoalDescription(goal: any): Promise<void> {
        const modal = await this._modalController.create({
            component: GoalDescriptionModal,
            cssClass: 'goal-description-modal',
            componentProps: {
                title: goal.title,
                description: goal.description
            }
        });
        await modal.present();
    }
}
